import { useEffect } from "react";

const SUFFIX = "CloudoX preview";

/**
 * Give each route its own document title.
 *
 * Every page shared one static title, so browser history, bookmarks and a
 * screen reader's page announcement all said the same thing regardless of what
 * the reader had navigated to.
 */
export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} — ${SUFFIX}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
